import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore';
import { saveTokenInLocalStorage } from '../../services/AuthService';

// image
import uniLogo from './../../images/uniempleo-logo-nuevo.png';
import loginbg from '../../images/portada-uniempleo.png';

export function LoginPage(props) {
	const location = useLocation();

	// URL del CAS de UNICARIBE
	const CAS_LOGIN_URL = process.env.REACT_APP_CAS_LOGIN_URL || 'https://login.unicaribe.edu.do/cas/login';
	const SERVICE_URL = process.env.REACT_APP_SERVICE_URL || `${window.location.origin}/login`;
	const CAS_SSO_URL = `${CAS_LOGIN_URL}?service=${encodeURIComponent(SERVICE_URL)}`;

	// Verificar si el login tradicional está habilitado desde variable de entorno
	const ENABLE_TRADITIONAL_LOGIN = process.env.REACT_APP_ENABLE_TRADITIONAL_LOGIN === 'true';
	
	// Verificar si el registro de usuarios está habilitado
	const ENABLE_USER_REGISTRATION = process.env.REACT_APP_ENABLE_USER_REGISTRATION === 'true';
	
	// URL de registro según configuración
	const REGISTER_URL = ENABLE_USER_REGISTRATION ? '/register' : '/register-2?type=employer';

	// Detectar si viene el parámetro ?as=company para mostrar login de empresa
	const queryParams = new URLSearchParams(location.search);
	const loginAsCompany = queryParams.get('as') === 'company';

	// Estado para alternar entre SSO y login tradicional
	// Si viene ?as=company, mostrar directamente el formulario tradicional
	const [showTraditionalLogin, setShowTraditionalLogin] = useState(loginAsCompany);

	// Estados del formulario tradicional
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	let errorsObj = { email: '', password: '' };
	const [errors, setErrors] = useState(errorsObj);

	// Zustand store
	const { login, loginConfirmed, setLoading, successMessage, showLoading, isAuthenticated, auth } = useAuthStore();

	// Redirigir si ya está autenticado
	useEffect(() => {
		if (isAuthenticated()) {
			// Redirigir según el tipo de perfil
			if (auth.user?.tipoPerfil === 'EMPRESA') {
				props.history.push('/company-profile');
			} else {
				props.history.push('/home');
			}
		}
	}, []);

	function onLogin(e) {
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };

		if (email === '') {
			errorObj.email = 'El correo electrónico es requerido';
			error = true;
		}

		if (password === '') {
			errorObj.password = 'La contraseña es requerida';
			error = true;
		}

		setErrors(errorObj);

		if (error) {
			return;
		}

		setLoading(true);
		login(email, password, props.history);
	}

	// Manejar el callback de CAS cuando regresa a la aplicación
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const ticket = queryParams.get('ticket');
		const error = queryParams.get('error');

		if (error) {
			console.error('Error en CAS:', error);
			// Mostrar mensaje de error
			return;
		}

		if (ticket) {
			// Enviar el ticket al backend para validarlo con CAS
			handleCASCallback(ticket);
		}
	}, [location]);

	const handleCASCallback = async (ticket) => {
		try {
			setLoading(true);

			const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/auth/cas/callback`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					ticket,
					service: SERVICE_URL
				})
			});

			const data = await response.json();

		if (response.ok) {
			// Preparar datos base para saveTokenInLocalStorage
			const tokenDetails = {
				access_token: data.token,
				user: {
					id: data.user.id,
					email: data.user.email,
					nombre: data.user.nombre,
					apellido: data.user.apellido,
					tipoPerfil: data.user.tipoPerfil,
					estado: data.user.estado
				}
			};

			// Usar la función helper para guardar y calcular expireDate
			saveTokenInLocalStorage(tokenDetails);

			// Recuperar de localStorage y agregar datos CAS
			let stored = JSON.parse(localStorage.getItem('userDetails'));
			stored.casUsername = data.casData?.username;
			stored.casAttributes = data.casData?.attributes;
			
			// Guardar nuevamente con los datos CAS incluidos
			localStorage.setItem('userDetails', JSON.stringify(stored));

			// Actualizar el store con todos los datos
			loginConfirmed(stored);

			// Redirigir según el tipo de perfil
			if (data.user.tipoPerfil === 'EMPRESA') {
				props.history.push('/company-profile');
			} else {
				props.history.push('/home');
			}
		} else {
				console.error('Error al autenticar:', data.message);
				alert('Error al iniciar sesión con CAS: ' + (data.message || 'Error desconocido'));
			}
		} catch (error) {
			console.error('Error en callback CAS:', error);
			alert('Error de conexión al autenticar con CAS');
		} finally {
			setLoading(false);
		}
	};

	const handleSSOLogin = () => {
		// Redirigir a la página de login de CAS UNICARIBE
		window.location.href = CAS_SSO_URL;
	};

	return (
		<div className="page-wraper" style={{ height: "100vh", overflow: "hidden", margin: 0, padding: 0 }}>
			<div className="page-content bg-white login-style2" style={{ height: "100vh", overflow: "hidden", margin: 0, padding: 0 }}>
				<div className="dez-bnr-inr dez-bnr-inr-md overlay-black-middle" style={{ backgroundImage: "url(" + loginbg + ")", height: "100vh", margin: 0, padding: 0 }}>
					<div className="section-full" style={{ height: "100vh", margin: 0, padding: 0 }}>
						<div className="container-fluid p-a0" style={{ height: "100vh", margin: 0, padding: 0, overflow: "hidden" }}>
							<div className="row" style={{ height: "100vh", margin: 0, padding: 0 }}>
								<div className="col-lg-4 col-md-4 col-sm-12 p-a0" style={{ height: "100vh", overflow: "hidden" }}>
									<div className="submit-resume p-a40 seth bg-white" style={{ height: "100vh", borderRadius: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflowY: "auto" }}>
										<div className="nav">
											<div className="logo m-b30">
												<Link to={"/"}><img src={uniLogo} alt="UNIEMPLEO" style={{ maxWidth: '180px' }} /></Link>
											</div>
											<div className="col-12 p-a0">
												<h3 className="m-b20" style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333' }}>
													{showTraditionalLogin ? 'Iniciar Sesión - Empresa' : 'Iniciar Sesión'}
												</h3>
												<p className="font-weight-600 m-b30" style={{ color: '#666', fontSize: '0.95rem' }}>
													{showTraditionalLogin 
														? 'Ingresa con tu correo y contraseña de empresa' 
														: 'Inicia sesión con tu cuenta de UNICARIBE'}
												</p>

												{successMessage && (
													<div className='bg-green-300 text-green-900 border border-green-900 p-2 my-2' style={{ borderRadius: '4px' }}>
														{successMessage}
													</div>
												)}

												{/* Botón de SSO con CAS UNICARIBE - Método Principal */}
												{!showTraditionalLogin && (
													<>
														<div className="m-t30">
															<button
																type="button"
																onClick={handleSSOLogin}
																className="site-button btn-block"
																style={{
																	backgroundColor: showLoading ? '#cccccc' : '#009247',
																	borderColor: showLoading ? '#cccccc' : '#009247',
																	padding: '12px',
																	fontSize: '1rem',
																	fontWeight: 600,
																	marginBottom: '15px',
																	cursor: showLoading ? 'not-allowed' : 'pointer',
																	opacity: showLoading ? 0.6 : 1,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	gap: '10px'
																}}
																disabled={showLoading}
															>
																{showLoading ? (
																	<>
																		<i className="fa fa-spinner fa-spin"></i>
																		<span>Autenticando...</span>
																	</>
																) : (
																	<>
																		<i className="fa fa-university"></i>
																		<span>Iniciar Sesión con UNICARIBE</span>
																	</>
																)}
															</button>
														</div>

														{/* Mostrar opción de login tradicional solo si está habilitado */}
														{ENABLE_TRADITIONAL_LOGIN && (
															<div className="text-center" style={{ margin: '20px 0' }}>
																<button
																	type="button"
																	onClick={() => setShowTraditionalLogin(true)}
																	style={{
																		background: 'none',
																		border: 'none',
																		color: '#666',
																		fontSize: '13px',
																		cursor: 'pointer',
																		textDecoration: 'underline'
																	}}
																>
																	Iniciar sesión como empresa
																</button>
															</div>
														)}
													</>
												)}

												{/* Formulario de login tradicional - Solo para empresas */}
												{ENABLE_TRADITIONAL_LOGIN && showTraditionalLogin && (
													<form onSubmit={onLogin} className="col-12 p-a0">
														<div className="alert alert-info" style={{ fontSize: '13px', padding: '10px', marginBottom: '20px' }}>
															<i className="fa fa-info-circle"></i> Este formulario es solo para <strong>empresas</strong>. Los usuarios normales deben usar CAS de UNICARIBE.
														</div>
														
														<div className="form-group m-b20">
															<label className="font-weight-600" style={{ marginBottom: '8px', display: 'block' }}>Correo Electrónico *</label>
															<div className="input-group">
																<input type="email" className="form-control"
																	placeholder="correo@ejemplo.com"
																	value={email}
																	onChange={(e) => setEmail(e.target.value)}
																	style={{ padding: '12px 15px' }}
																/>
															</div>
															{errors.email && <div className="text-danger fs-12 mt-1">{errors.email}</div>}
														</div>
														<div className="form-group m-b25">
															<label className="font-weight-600" style={{ marginBottom: '8px', display: 'block' }}>Contraseña *</label>
															<div className="input-group">
																<input
																	type="password"
																	className="form-control"
																	value={password}
																	placeholder="Ingresa tu contraseña"
																	onChange={(e) =>
																		setPassword(e.target.value)
																	}
																	style={{ padding: '12px 15px' }}
																/>
															</div>
															{errors.password && <div className="text-danger fs-12 mt-1">{errors.password}</div>}
														</div>
														<div className="m-t30">
															<button
																className="site-button btn-block"
																style={{
																	backgroundColor: showLoading ? '#cccccc' : '#009247',
																	borderColor: showLoading ? '#cccccc' : '#009247',
																	padding: '12px',
																	fontSize: '1rem',
																	fontWeight: 600,
																	marginBottom: '15px',
																	cursor: showLoading ? 'not-allowed' : 'pointer',
																	opacity: showLoading ? 0.6 : 1
																}}
																disabled={showLoading}
															>
																{showLoading ? (
																	<>
																		<i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
																		Iniciando sesión...
																	</>
																) : 'Iniciar Sesión'}
															</button>
														</div>

														<div className="text-center" style={{ marginBottom: '12px' }}>
															<Link
																to="/auth/forgot-password"
																style={{ color: '#009247', fontSize: '13px', textDecoration: 'none' }}
															>
																¿ Olvidaste tu contraseña?
															</Link>
														</div>

														<div className="text-center" style={{ margin: '20px 0' }}>
															<button
																type="button"
																onClick={() => setShowTraditionalLogin(false)}
																style={{
																	background: 'none',
																	border: 'none',
																	color: '#666',
																	fontSize: '13px',
																	cursor: 'pointer',
																	textDecoration: 'underline'
																}}
															>
																← Volver a inicio con UNICARIBE
															</button>
														</div>
													</form>
												)}

												<div className="text-center" style={{ marginTop: '20px' }}>
													<span style={{ color: '#666', fontSize: '13px' }}>¿No tienes cuenta? </span>
													<Link
														to={REGISTER_URL}
														style={{
															color: '#00004C',
															fontSize: '13px',
															fontWeight: '600',
															textDecoration: 'none',
															transition: 'color 0.3s ease'
														}}
													>
														{ENABLE_USER_REGISTRATION ? 'Crear Cuenta' : 'Registrar Empresa'}
													</Link>
												</div>

											</div>
											<div className="bottom-footer clearfix row text-center" style={{ padding: '0px 0 8px', marginTop: '20px', borderTop: '1px solid #e9ecef' }}>
												<div className="col-lg-12 text-center">
													<span style={{ fontSize: '11px', color: '#999' }}>© {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. Todos los derechos reservados.</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};